"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  appName: () => appName,
  buildMeterCarrier: () => buildMeterCarrier,
  buildTraceCarrier: () => buildTraceCarrier,
  calculateTraceSamplingRatio: () => calculateTraceSamplingRatio,
  clientType: () => clientType,
  criticalPathsSampled: () => criticalPathsSampled,
  defaultBannerId: () => defaultBannerId,
  defaultFeatureFlags: () => defaultFeatureFlags,
  defaultGCDurationBuckets: () => defaultGCDurationBuckets,
  defaultHeaders: () => defaultHeaders,
  defaultTracesSampleRatio: () => defaultTracesSampleRatio,
  defaultUserId: () => defaultUserId,
  escapeBaseUrl: () => escapeBaseUrl,
  getExtendedAttributes: () => getExtendedAttributes,
  getFetchBodyLength: () => getFetchBodyLength,
  getFetchEventsDuration: () => getFetchEventsDuration,
  getOpAggregateErrorsCounter: () => getOpAggregateErrorsCounter,
  getOpDurationHistogram: () => getOpDurationHistogram,
  getOpErrorsCounter: () => getOpErrorsCounter,
  getOpNetworkDurationHistogram: () => getOpNetworkDurationHistogram,
  getOpSloErrorsCounter: () => getOpSloErrorsCounter,
  getOpTotalCounter: () => getOpTotalCounter,
  getOtelCarrierFromDom: () => getOtelCarrierFromDom,
  getPageKey: () => getPageKey,
  getPageUrls: () => getPageUrls,
  getSLOErrorsFromViewDefinition: () => getSLOErrorsFromViewDefinition,
  getXHRBodyLength: () => getXHRBodyLength,
  injectRequestHeadersDirectly: () => injectRequestHeadersDirectly,
  injectResponseHeaders: () => injectResponseHeaders,
  isJestRuntime: () => isJestRuntime,
  isMatchingUrl: () => isMatchingUrl,
  isNodeRuntime: () => isNodeRuntime,
  isOtelDebugLogging: () => isOtelDebugLogging,
  isOtelEnabled: () => isOtelEnabled,
  isOtelExportLogging: () => isOtelExportLogging,
  isTraceSampled: () => isTraceSampled,
  isW3CSupported: () => isW3CSupported,
  loadSLOThreshold: () => loadSLOThreshold,
  loggingUrl: () => loggingUrl,
  measureDuration: () => measureDuration,
  meter: () => meter,
  metricsIntervalMs: () => metricsIntervalMs,
  metricsUrl: () => metricsUrl,
  normalizeHeaders: () => normalizeHeaders,
  readResponseStream: () => readResponseStream,
  resourceAttributes: () => resourceAttributes,
  setActiveTraceContext: () => setActiveTraceContext,
  tracer: () => tracer,
  tracesUrl: () => tracesUrl
});
module.exports = __toCommonJS(index_exports);

// src/constants/setup.ts
var import_semantic_conventions = require("@opentelemetry/semantic-conventions");
var import_uuid = require("uuid");
var isNodeRuntime = typeof window === "undefined" || !!process.env.NEXT_RUNTIME || typeof process === "object" && process.release?.name === "node";
var isJestRuntime = process.env.JEST_WORKER_ID !== void 0 || process.env.NODE_ENV === "test";
var isOtelBypass = typeof window !== "undefined" && window.location.search.includes("disable-otel");
var isOtelEnabled = !isOtelBypass && process.env.NEXT_PUBLIC_OTEL_ENABLED === "true";
var isOtelDebugLogging = process.env.NEXT_PUBLIC_OTEL_DEBUG_LOGGING === "true";
var isOtelExportLogging = process.env.NEXT_PUBLIC_OTEL_EXPORT_LOGGING === "true";
var tracesUrl = process.env.NEXT_PUBLIC_OTEL_TRACES_URL || "invalid-url";
var metricsUrl = process.env.NEXT_PUBLIC_OTEL_METRICS_URL || "invalid-url";
var loggingUrl = process.env.NEXT_PUBLIC_OTEL_LOGS_URL || "invalid-url";
var appName = process.env.NEXT_PUBLIC_OTEL_CLIENT_NAME || "invalid-app-name";
var metricsIntervalMs = Number(process.env.NEXT_PUBLIC_OTEL_METRICS_INTERVAL_MS ?? 12e4);
var clientType = process.env.NEXT_PUBLIC_OTEL_CLIENT_TYPE || "default-client-type";
var criticalPathsSampled = process.env.NEXT_PUBLIC_OTEL_CRITICAL_PATHS_SAMPLED || "default-critical-paths-sampled";
var loadSLOThreshold = Number(process.env.NEXT_PUBLIC_OTEL_SLO_THRESHOLD) || 2 * 1e3;
var isW3CSupported = process.env.NEXT_PUBLIC_OTEL_W3C_SUPPORT === "true";
var defaultTracesSampleRatio = Number(process.env.NEXT_PUBLIC_OTEL_TRACES_RATIO ?? 1);
var defaultUserId = (0, import_uuid.v4)();
var defaultBannerId = process.env.NEXT_PUBLIC_OTEL_BANNER || "invalid-banner";
var resourceAttributes = {
  [import_semantic_conventions.ATTR_SERVICE_NAME]: appName,
  "ld.lob": process.env.NEXT_PUBLIC_OTEL_LOB,
  "ld.banner": defaultBannerId,
  "ld.client.version": process.env.NEXT_PUBLIC_OTEL_CLIENT_VERSION
};
var defaultGCDurationBuckets = [
  2e-3,
  4e-3,
  8e-3,
  0.016,
  0.032,
  0.064,
  0.128,
  0.256,
  0.512,
  1.02,
  2.05,
  4.1,
  8.2,
  16.4,
  32.8
];
var defaultHeaders = {
  "Content-Type": "application/json"
};
var defaultFeatureFlags = { status: false, alwaysOnTracingUserIds: [], traceSamplingRatio: 0 };

// src/utils/fetch.ts
var import_api = require("@opentelemetry/api");
var otelLogger = import_api.diag.createComponentLogger({
  namespace: "\u2728 @e-comm-platform/web-otel-sdk/utils/fetch"
});
var TEXT_ENCODER = new TextEncoder();
var getFetchBodyLength = async (isMeasuringBodyLength, ...args) => {
  try {
    if (!isMeasuringBodyLength) return void 0;
    if (args[0] instanceof URL || typeof args[0] === "string") {
      const requestInit = args[1];
      if (!requestInit?.body) return void 0;
      if (requestInit.body instanceof ReadableStream) {
        const { body, length } = _getBodyNonDestructively(requestInit.body);
        requestInit.body = body;
        return length;
      } else {
        return getXHRBodyLength(requestInit.body);
      }
    } else {
      const info = args[0];
      if (!info?.body) return void 0;
      const text = await info.clone().text();
      return getByteLength(text);
    }
  } catch (error) {
    otelLogger.error("Error in getFetchBodyLength:", error);
    return void 0;
  }
};
var _getBodyNonDestructively = (body) => {
  if (!body.pipeThrough) {
    otelLogger.warn("Platform has ReadableStream but not pipeThrough!");
    return {
      body,
      length: Promise.resolve(void 0)
    };
  }
  let length = 0;
  let resolveLength;
  const lengthPromise = new Promise((resolve) => {
    resolveLength = resolve;
  });
  const transform = new TransformStream({
    start() {
    },
    async transform(chunk, controller) {
      const bytearray = await chunk;
      length += bytearray.byteLength;
      controller.enqueue(chunk);
    },
    flush() {
      resolveLength(length);
    }
  });
  return {
    body: body.pipeThrough(transform),
    length: lengthPromise
  };
};
var isDocument = (value) => {
  return typeof Document !== "undefined" && value instanceof Document;
};
var getXHRBodyLength = (body) => {
  if (isDocument(body)) {
    return new XMLSerializer().serializeToString(document).length;
  }
  if (typeof body === "string") {
    return getByteLength(body);
  }
  if (body instanceof Blob) {
    return body.size;
  }
  if (body instanceof FormData) {
    return getFormDataSize(body);
  }
  if (body instanceof URLSearchParams) {
    return getByteLength(body.toString());
  }
  if (body.byteLength !== void 0) {
    return body.byteLength;
  }
  otelLogger.warn("unknown body type");
  return void 0;
};
var getByteLength = (s) => {
  return TEXT_ENCODER.encode(s).byteLength;
};
var getFormDataSize = (formData) => {
  let size = 0;
  for (const [key, value] of formData.entries()) {
    size += key.length;
    if (value instanceof Blob) {
      size += value.size;
    } else {
      size += value.length;
    }
  }
  return size;
};
var normalizeHeaders = (headers) => {
  if (!headers) return {};
  if (headers instanceof Headers) {
    return Object.fromEntries(headers.entries());
  } else if (Array.isArray(headers)) {
    return Object.fromEntries(headers);
  }
  return { ...headers };
};
var injectRequestHeadersDirectly = (request, traceCarrier, bodyLength) => {
  if (request instanceof Request) {
    Object.entries(traceCarrier).forEach(([key, val]) => {
      request.headers.set(key, val);
    });
    if (bodyLength === 0) request.headers.delete("content-type");
    return request;
  } else {
    return injectRequestInitHeaders(request, traceCarrier);
  }
};
var injectRequestInitHeaders = (request, traceCarrier) => {
  const newRequestInit = { ...request, headers: normalizeHeaders(request.headers) };
  Object.entries(traceCarrier).forEach(([key, val]) => {
    newRequestInit.headers[key] = val;
  });
  return newRequestInit;
};
var injectResponseHeaders = (response, traceCarrier) => {
  const resClone = response.clone();
  const newHeaders = new Headers(resClone.headers);
  Object.entries(traceCarrier).forEach(([key, val]) => {
    newHeaders.set(key, val);
  });
  const newResponse = new Response(resClone.body, {
    // cannot use spread operator, it will mark body as bodyUsed: true
    status: resClone.status,
    statusText: resClone.statusText,
    headers: newHeaders
  });
  return newResponse;
};
var readResponseStream = async (response) => {
  const spanResClone = response.clone();
  if (spanResClone.body) {
    const reader = spanResClone.body.getReader();
    try {
      while (true) {
        const { done } = await reader.read();
        if (done) break;
      }
    } catch (error) {
      throw error;
    }
  }
};

// src/utils/metrics.ts
var import_api2 = require("@opentelemetry/api");
var meter = () => import_api2.metrics.getMeter(`${appName}-meter`);
var buildMeterCarrier = (ssrFetchDurationMs, backendFetchErrors) => {
  return {
    ssrFetchDurationMs,
    backendFetchErrors
  };
};
var getFetchEventsDuration = (fetchEvents) => {
  if (fetchEvents.length === 0) return 0;
  return fetchEvents.reduce((acc, event) => acc + (event.duration || 0), 0);
};
var measureDuration = async (fn) => {
  const startTime = performance.now();
  const result = await fn();
  const duration = performance.now() - startTime;
  return { result, duration };
};
var getSLOErrorsFromViewDefinition = (data) => {
  return [data.viewDefinitionResults === null, data.themeTokens === null, data.cartData === null].reduce(
    (acc, curr) => acc + (curr ? 1 : 0),
    0
  );
};
var getOpTotalCounter = (pageKey) => meter().createCounter(`${pageKey}_op_total`, {
  description: "Number of time page is accessed by the client (cumulative)",
  valueType: import_api2.ValueType.INT
});
var getOpErrorsCounter = (pageKey) => meter().createCounter(`${pageKey}_op_errors`, {
  description: "Number of times page access yield error(s) (cumulative)",
  valueType: import_api2.ValueType.INT
});
var getOpSloErrorsCounter = (pageKey) => meter().createCounter(`${pageKey}_op_slo_errors`, {
  description: "Number of times a route breached the SLO",
  valueType: import_api2.ValueType.INT
});
var getOpAggregateErrorsCounter = (pageKey) => meter().createCounter(`${pageKey}_op_aggregate_errors`, {
  description: "Number of times either an error or SLO breach occurred during page load",
  valueType: import_api2.ValueType.INT
});
var getOpNetworkDurationHistogram = (pageKey) => meter().createHistogram(`${pageKey}_op_network_duration`, {
  description: "Total latency of REST calls for page (cumulative) ",
  valueType: import_api2.ValueType.DOUBLE,
  advice: {
    explicitBucketBoundaries: defaultGCDurationBuckets
  }
});
var getOpDurationHistogram = (pageKey) => meter().createHistogram(`${pageKey}_op_duration`, {
  description: "Total time to render complete of the page (cumulative) ",
  valueType: import_api2.ValueType.DOUBLE,
  advice: {
    explicitBucketBoundaries: defaultGCDurationBuckets
  }
});

// src/utils/setup.ts
var getExtendedAttributes = (pathName, bannerId, userId) => ({
  ...resourceAttributes,
  "ld.path": pathName,
  "ld.banner": bannerId,
  "ld.user.id": userId
});
var queryDomJson = (selector) => {
  try {
    const text = document.querySelector(selector)?.textContent?.replace(/;$/, "");
    return text ? JSON.parse(text) : void 0;
  } catch (err) {
    console.error("queryDomJson", { selector, err });
    return void 0;
  }
};
var getOtelCarrierFromDom = () => {
  const domTraceCarrier = queryDomJson("#otel-trace-carrier");
  const domMeterCarrier = queryDomJson("#otel-meter-carrier");
  const domFeatureFlags = queryDomJson("#otel-feature-flags");
  const domNextData = queryDomJson("#__NEXT_DATA__");
  const nextData = domNextData || window.__NEXT_DATA__;
  const traceCarrier = domTraceCarrier || void 0;
  const meterCarrier = domMeterCarrier || nextData?.props?.pageProps?.meterCarrier;
  const featureFlags = domFeatureFlags || void 0;
  const result = {
    traceCarrier,
    meterCarrier,
    featureFlags
  };
  return result;
};

// src/utils/traces.ts
var import_api3 = require("@opentelemetry/api");
var import_api4 = require("@opentelemetry/api");
var otelLogger2 = import_api4.diag.createComponentLogger({
  namespace: "\u2728 @e-comm-platform/web-otel-sdk/utils/traces"
});
var tracer = () => import_api3.trace.getTracer(`${appName}-tracer`);
var setActiveTraceContext = (traceCarrier) => {
  if (!traceCarrier) return;
  return import_api3.propagation.extract(import_api3.context.active(), traceCarrier);
};
var buildTraceCarrier = (span) => {
  const carrier = {};
  const spanContext = span ? import_api3.trace.setSpan(import_api3.context.active(), span) : import_api3.context.active();
  if (isW3CSupported) carrier.tracestate = addTraceState(carrier.tracestate, String(criticalPathsSampled));
  import_api3.propagation.inject(spanContext, carrier);
  return carrier;
};
function addTraceState(traceState, value) {
  if (!value) return traceState;
  return traceState ? `${traceState},${value}` : value;
}
function isTraceSampled() {
  const activeSpan = import_api3.trace.getSpan(import_api3.context.active());
  otelLogger2.info("activeSpan ==> ", activeSpan);
  return activeSpan ? (activeSpan.spanContext().traceFlags & 1) === 1 : false;
}
function calculateTraceSamplingRatio(featureFlags) {
  if (!featureFlags.status) return 0;
  const remoteTracingRatio = featureFlags?.traceSamplingRatio;
  return remoteTracingRatio != void 0 ? remoteTracingRatio : defaultTracesSampleRatio;
}

// src/utils/url.ts
var import_escapeRegExp = __toESM(require("lodash/escapeRegExp"));
var isMatchingUrl = (url, matchingUrls) => {
  return matchingUrls?.some((urlToMatch) => {
    if (typeof urlToMatch === "string") {
      return url === urlToMatch;
    } else {
      return !!url.match(urlToMatch);
    }
  }) || false;
};
var getPageUrls = (pageUrlsMap) => {
  return Object.values(pageUrlsMap).filter((pageUrl) => pageUrl !== void 0);
};
var getPageKey = (url, pageUrlsMap) => {
  for (const pageKey in pageUrlsMap) {
    const allowedUrl = pageUrlsMap[pageKey];
    if (isMatchingUrl(url, allowedUrl ? [allowedUrl] : void 0)) {
      return pageKey;
    }
  }
};
var escapeBaseUrl = (baseUrl) => {
  if (!baseUrl?.trim()) return void 0;
  return new RegExp(`^${(0, import_escapeRegExp.default)(baseUrl)}`);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  appName,
  buildMeterCarrier,
  buildTraceCarrier,
  calculateTraceSamplingRatio,
  clientType,
  criticalPathsSampled,
  defaultBannerId,
  defaultFeatureFlags,
  defaultGCDurationBuckets,
  defaultHeaders,
  defaultTracesSampleRatio,
  defaultUserId,
  escapeBaseUrl,
  getExtendedAttributes,
  getFetchBodyLength,
  getFetchEventsDuration,
  getOpAggregateErrorsCounter,
  getOpDurationHistogram,
  getOpErrorsCounter,
  getOpNetworkDurationHistogram,
  getOpSloErrorsCounter,
  getOpTotalCounter,
  getOtelCarrierFromDom,
  getPageKey,
  getPageUrls,
  getSLOErrorsFromViewDefinition,
  getXHRBodyLength,
  injectRequestHeadersDirectly,
  injectResponseHeaders,
  isJestRuntime,
  isMatchingUrl,
  isNodeRuntime,
  isOtelDebugLogging,
  isOtelEnabled,
  isOtelExportLogging,
  isTraceSampled,
  isW3CSupported,
  loadSLOThreshold,
  loggingUrl,
  measureDuration,
  meter,
  metricsIntervalMs,
  metricsUrl,
  normalizeHeaders,
  readResponseStream,
  resourceAttributes,
  setActiveTraceContext,
  tracer,
  tracesUrl
});
